import config from 'frontend/config/environment';
import EmberRouter from '@embroider/router';

export default class Router extends EmberRouter {
  location = config.locationType;
  rootURL = config.rootURL;
}

Router.map(function () {
  this.route('404', { path: '/*path' });
  this.route('login');
  this.route('logout');
  this.route('forgot-password');
  this.route('reset-password');
  this.route('register');
  this.route('catalog', { path: 'catalogue' }, function () {
    this.route('product', { path: 'formation/:slug' });
    this.route('action', { path: 'action/:slug' }, function () {
      this.route('apply', { path: 'inscription' }, function () {
        this.route('thank-you');
      });
    });
  });
  this.route('formations', function () {});
  this.route('dashboard', function () {
    this.route('profile');
    this.route('favorites');
    this.route('applies');
  });
});
